import {useSelector} from "react-redux";


const TitleWithArchiveCode = ({code}) => {
  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);

  return (
    <div className={"title-wrapper"}>
      <div className={"title-and-product-code"}>
        <div className={"title"}>My Design Archive</div>
        <div className={"product-code"}>
          <span>{`${currentProduct?.displayTitle?.toUpperCase()} ${currentProduct?.displaySubtitle?.toUpperCase()}`}</span>
        </div>
      </div>
      <div className={"my-archive-code"}>
        <span className={"my-archive-code-label"}>My archive code : </span>
        <span className={"code"}> {code} </span>
      </div>
    </div>
  )
}

export default TitleWithArchiveCode;
